import { defineMessages } from "react-intl";

export const fitmentMessages = defineMessages({
  refreshFailed: {
    defaultMessage:
      "Fitment could not be re-read. What is shown may be out of date; unsaved edits are kept.",
    id: "/hef+/",
    description: "product fitment tab, a re-read failed while cards are shown",
  },
  savedButNotReread: {
    defaultMessage:
      "Saved, but the product's fitment could not be re-read. Retry the read before editing further.",
    id: "bg4a3r",
    description: "product fitment card, the write succeeded but the refetch after it failed",
  },
  loadFailed: {
    defaultMessage: "Fitment could not be loaded",
    id: "yM4iSb",
    description: "product fitment tab, load error",
  },
  noSchemas: {
    defaultMessage:
      "No active fitment schema. Create one under Fitment before assigning fitment to a product.",
    id: "8T6tDN",
    description: "product fitment tab, no schemas",
  },
  unknown: {
    defaultMessage: "Fitment unknown: this product has not been told what it fits here.",
    id: "4Pb8hn",
    description: "product fitment schema card, no row",
  },
  universal: {
    defaultMessage: "Universal (fits everything in this schema)",
    id: "nnCHTE",
    description: "product fitment schema card, universal checkbox",
  },
  knownEmpty: {
    defaultMessage: "Fits nothing in this schema (a known empty set).",
    id: "lXbTAB",
    description: "product fitment schema card, empty application list",
  },
  resolving: {
    defaultMessage:
      "Resolving {count, plural, one {# application} other {# applications}} the product carries...",
    id: "0/SKon",
    description: "product fitment schema card, applications still being resolved",
  },
  applicationsLoadFailed: {
    defaultMessage: "The product's applications could not be read back; they are listed by id.",
    id: "tlDda+",
    description: "product fitment schema card, applications read error",
  },
  addApplication: {
    defaultMessage: "Add application",
    id: "PHqykX",
    description: "product fitment schema card, button",
  },
  remove: {
    defaultMessage: "Remove",
    id: "H0UfWi",
    description: "product fitment schema card, remove one application",
  },
  forget: {
    defaultMessage: "Forget fitment",
    id: "MSeEkY",
    description: "product fitment schema card, delete the product-schema row",
  },
  forgetTitle: {
    defaultMessage: "Forget fitment under {schema}?",
    id: "rxqize",
    description: "product fitment schema card, forget dialog title",
  },
  forgetContent: {
    defaultMessage:
      "The product's fitment under {schema} becomes unknown: not universal, not empty, simply not stated. Its applications stay in the vocabulary.",
    id: "GSuH7x",
    description: "product fitment schema card, forget dialog content",
  },
  addDialogTitle: {
    defaultMessage: "Add application to {schema}",
    id: "eu56Mw",
    description: "product fitment add dialog, title",
  },
  addDialogHint: {
    defaultMessage:
      "Pick one value per axis; leave an axis empty to keep it unconstrained. The application is created if it does not exist yet and added to this card; press Save to keep it on the product.",
    id: "iVJv9h",
    description: "product fitment add dialog, hint",
  },
  addDialogNeedsValue: {
    defaultMessage: "Pick at least one value.",
    id: "TerWcj",
    description: "product fitment add dialog, validation",
  },
  applicationQualifiers: {
    defaultMessage: "Qualifier values on this application",
    id: "Iaw6pp",
    description: "product fitment add dialog, qualifier multiselect label",
  },
  noAxisValues: {
    defaultMessage: "No values on this axis yet",
    id: "Hz1Sae",
    description: "product fitment add dialog, axis has no values",
  },
  qualifiersTitle: {
    defaultMessage: "Qualifiers",
    id: "be/hkw",
    description: "product fitment qualifier card, title",
  },
  qualifiersHint: {
    defaultMessage: "Qualifier values the product carries on its own, apart from any application.",
    id: "DCI1Ht",
    description: "product fitment qualifier card, hint",
  },
  qualifiersLabel: {
    defaultMessage: "Qualifier values",
    id: "ayq6js",
    description: "product fitment qualifier card, multiselect label",
  },
  noQualifiers: {
    defaultMessage: "No qualifiers defined.",
    id: "HvMDVa",
    description: "product fitment qualifier card, empty vocabulary",
  },
  anyAxis: {
    defaultMessage: "any {axis}",
    id: "hyrjpn",
    description: "product fitment application line, an axis the application leaves unconstrained",
  },
  markKnownEmpty: {
    defaultMessage: "Mark as fits nothing",
    id: "v5gySy",
    description: "product fitment schema card, button: state a known empty set on an unknown card",
  },
  keepUnknown: {
    defaultMessage: "Keep unknown",
    id: "sdFwhl",
    description: "product fitment schema card, button: undo mark as known empty before saving",
  },
  universalConfirmTitle: {
    defaultMessage: "Make {schema} universal?",
    id: "gNninC",
    description: "product fitment schema card, universal confirmation title",
  },
  universalConfirmContent: {
    defaultMessage:
      "Saving as universal removes {kind, select, both {{saved} saved and {unsaved} unsaved {total, plural, one {application} other {applications}}} unsaved {{unsaved, plural, one {# unsaved application} other {# unsaved applications}}} other {{saved, plural, one {# application link} other {# application links}}}} from this product under {schema}. The applications stay in the vocabulary.",
    id: "7tjh+Z",
    description:
      "product fitment schema card, universal confirmation content; kind is saved, unsaved or both",
  },
  universalConfirm: {
    defaultMessage: "Make universal",
    id: "syWb3Z",
    description: "product fitment schema card, universal confirmation button",
  },
  inactiveSchema: {
    defaultMessage:
      "This schema is inactive. Its fitment is shown read-only; forget it to clear the row.",
    id: "ERACZt",
    description: "product fitment schema card, inactive schema note",
  },
  filterApplications: {
    defaultMessage: "Filter applications",
    id: "o+XORY",
    description: "product fitment schema card, application filter input label",
  },
  noFilterMatch: {
    defaultMessage: "No application matches the filter.",
    id: "qys7F4",
    description: "product fitment schema card, filter matches nothing",
  },
});
